module.exports = __webpack_public_path__ + "static/media/opensans-semibold.935231c6.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/opensans-semibold.woff2
// module id = 87
// module chunks = 0